import React from 'react';
import { useSelector } from 'react-redux';
import { DashboardSelectWrapper } from '../../../healtheraComponents';
import useLocationQuery from '../../../hooks/useQuery';
import {
  SELECT_ORDER_TYPES_WITH_LABELS,
  SELECT_ORDER_STATUSES_WITH_LABELS,
} from '../constants';
import Chips from '../../Chips';
import GroupButtons from '../../Shared/GroupButtons';

const DashboardSelect = () => {
  const { query, changeLocationQuery } = useLocationQuery();
  const defaultTypes = query?.type?.split(',');
  const defaultSelectedTypes = defaultTypes?.length ? defaultTypes : [SELECT_ORDER_TYPES_WITH_LABELS[0].value];
  const { counts } = useSelector((state) => state.dashboard);
  const selectedStatus = SELECT_ORDER_STATUSES_WITH_LABELS.find(item => item.value === query?.status);
  const defaultSelectedStatus = selectedStatus?.value || SELECT_ORDER_STATUSES_WITH_LABELS[0].value;

  const handleChangePharmacyType = (selectedItems) => {
    const { pharmacy_id, ...restQuery } = query;
    changeLocationQuery({
      ...restQuery,
      type: selectedItems,
      page: 0,
    })
  };

  const handleChangeStatus = (newStatus) => {
    changeLocationQuery({
      ...query,
      status: newStatus,
      page: 0,
    });
  }

  const statusMenuItems = counts
    ? SELECT_ORDER_STATUSES_WITH_LABELS.map(item => ({
      ...item,
      label: `${item.label} (${counts[item.value] || 0})`,
    }))
    : SELECT_ORDER_STATUSES_WITH_LABELS;

  return (
    <DashboardSelectWrapper>
      <Chips
        items={SELECT_ORDER_TYPES_WITH_LABELS}
        onChange={handleChangePharmacyType}
        defaultSelected={defaultSelectedTypes}
      />
      <GroupButtons
        items={statusMenuItems}
        onChange={handleChangeStatus}
        selected={defaultSelectedStatus}
      />
    </DashboardSelectWrapper>
  );
};

export default DashboardSelect;
